import React from 'react';
import { Shimmer } from '@clover-reporting/shimmer-loader';

type ShimmerProps = { smallShimmer: boolean };

export const BackgroundShimmer: React.FC<ShimmerProps> = ({ smallShimmer }) => {
  const lines = smallShimmer
    ? [
        { spacing: 15, leftWidth: 95, rightWidth: 0, height: 10 },
        { spacing: 15, leftWidth: 95, rightWidth: 0, height: 10 },
      ]
    : [
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
        { spacing: 25, leftWidth: 95, rightWidth: 0, height: 20 },
      ];

  return <Shimmer style={{width: "100%"}} lines={lines} />;
};
